import { render } from "./fixedMenu.vue?vue&type=template&id=2d862327&scoped=true"
import script from "./fixedMenu.vue?vue&type=script&lang=js"
export * from "./fixedMenu.vue?vue&type=script&lang=js"

import "./fixedMenu.vue?vue&type=style&index=0&id=2d862327&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krist\\Documents\\pbetoon\\pBetoon-main\\ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d862327"]])

export default __exports__